import { render, staticRenderFns } from "./virtual-list.vue?vue&type=template&id=0c7935e4&scoped=true"
import script from "./virtual-list.vue?vue&type=script&lang=js"
export * from "./virtual-list.vue?vue&type=script&lang=js"
import style0 from "./virtual-list.vue?vue&type=style&index=0&id=0c7935e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7935e4",
  null
  
)

export default component.exports